import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { storage } from 'storage/sessionStorage';
import UserRoutes from 'config/UserRoutes';
import { getQueryParam } from 'utils/getQueryParam';
import { fetchUserDetails } from 'user/userSlice';
import { StandaloneModalType } from 'modals/useStandaloneModal';
import { useContext } from 'react';
import { StandaloneModalContext } from 'modals/StandaloneModalContext';
import { fetchWalletPage } from '../../wallet/walletSlice';

/*
  a single place to execute all the actions that should be executed after a successful login
*/
const useOnLoginSuccess = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const redirectPage = getQueryParam('redirect');
  const validRoutesRedirect = UserRoutes.map(route => route.path).includes(`/${redirectPage}`);
  const { showModal } = useContext(StandaloneModalContext);

  // eslint-disable-next-line consistent-return
  const onLoginSuccess = async (user) => {
    if (user?.userDataConsent?.isDisplayConsentScreen) {
      return history.push('/data-consent-terms');
    }
    const urlRedirectOnLogin = storage.getItem('url-redirect-on-login');
    if (urlRedirectOnLogin) {
      storage.removeItem('url-redirect-on-login');
      history.push(`/${urlRedirectOnLogin}`);
    }
    // redirect using query param Ex: ?redirect=elite
    if (redirectPage && validRoutesRedirect) {
      dispatch(fetchUserDetails());
      dispatch(fetchWalletPage());
      // additional parameters for ELITE
      const tierParam = getQueryParam('tier');
      const validTierParams = ['1', '2'];
      const params = new URLSearchParams();

      if (validTierParams.includes(tierParam)) {
        params.set('tier', tierParam);
      }

      const queryString = params.toString();
      const url = `/${redirectPage}${queryString ? `?${queryString}` : ''}`;

      history.push(url);
    }
  };

  const onPostLoginSuccess = () => {
    showModal(StandaloneModalType.MOBILE_POPUP_ON_LOGIN);
  };

  return { onLoginSuccess, onPostLoginSuccess };
};

export default useOnLoginSuccess;
